@if (pinOverrideDetail$ | async) {
  <div>
    <form [formGroup]="form">
      <div    class="flex-gap-12-5vw flex-space-between-center flex-row">
        <label class="mt-4">Name</label>
        <mat-form-field class="flex-40" >
          <input matInput
            formControlName="name"
            type="text"
            placeholder="Name"
            required
            >
        </mat-form-field>
      </div>
      <div    class="flex-gap-10vw flex-space-between-center flex-row">
        <label class="mt-4">Description</label>
        <mat-form-field class="flex-40" >
          <textarea matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="3"
            formControlName="description"
            type="text"
            placeholder="Description"
          ></textarea>
        </mat-form-field>
      </div>
      <div    class="flex-gap-9vw flex-space-between-center flex-row">
        <label class="mt-4">Effective&nbsp;Date</label>
        <mat-form-field class="flex-40" >
          <input matInput
            formControlName="effectiveDate"
            type="text"
            [matDatepicker]="effectiveDatePicker"
            [min]="today"
            value="{{ (selected | async)?.effectiveDate }}"
            >
          <mat-datepicker-toggle
            [attr.data-testid]="'effective_date_toggle'"
            [for]="effectiveDatePicker"
            matSuffix
          ></mat-datepicker-toggle>
          <mat-datepicker #effectiveDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
      @if (minEndDate | async) {
        <div    class="flex-gap-11vw flex-space-between-center flex-row">
          <label class="mt-4">End&nbsp;Date</label>
          <mat-form-field class="flex-40" >
            <input matInput
              formControlName="endDate"
              type="text"
              [matDatepicker]="endDatePicker"
              [min]="(selected | async)?.effectiveDate < today ? today : (minEndDate | async)"
              value="{{ (selected | async)?.endDate }}"
              >
            <mat-datepicker-toggle
              [attr.data-testid]="'effective_date_toggle'"
              [for]="endDatePicker"
              matSuffix
            ></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
      }
      <div    class="flex-gap-11vw flex-space-between-center flex-row">
        <label>Location Set Type</label>
        <mat-form-field class="flex-40" >
          <mat-select formControlName="locationSetType"
            placeholder="Select a Location Set Type"
            required
            (click)="editLocation()"
            >
            @for (locationSetType of (locationSetTypes$ | async); track locationSetType) {
              <mat-option
                [value]="locationSetType.tag"
                >
                {{ locationSetType.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (selectedLocationSetType) {
        <div    class="flex-gap-11vw flex-space-between-center flex-row">
          <label class="mt-4">Location</label>
          <mat-form-field class="flex-40" >
            <mat-select
              formControlName="location"
              placeholder="Select a Location or Location Set"
              required
              >
              @for (location of locationSets$ | async; track location) {
                <mat-option
                  [value]="location.tag"
                >{{ location.name }}</mat-option>
              }
              @if (!(locationSets$ | async)) {
                <mat-option
                  [value]="(selected | async)?.location">
                  {{ (selected | async)?.location }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      <div class="table-container">
        <table id="pin-overrides-table" class="emm-pin-overrides-table">
          <thead>
            <tr id="table-headers">
              <td class="pin-table-columns"><label>RMI</label></td>
              <td class="pin-table-columns"><label>Primary</label></td>
              <td class="pin-table-columns"><label>Secondary</label></td>
              <td class="pin-table-columns"><label>Whole Product</label></td>
              <td class="pin-table-columns"><label>Distribution Sampling</label></td>
              <td class="pin-table-columns">
                <button mat-button matTooltip="Add Row" id="add-row-button" (click)="addRow()">+</button>
              </td>
            </tr>
          </thead>
          <tbody>
            @if (model$ | async; as model) {
              @for (pinOverride of model.pinOverrides; track $index; let i = $index) {
                <tr
                  class="override-rows">
                <td class="pin-table-columns">
                  <input matInput class="form-control" type="number" id="{{ 'rmi' + i }}"
                    value="{{ pinOverride.rmi }}" (click)="editPins()" [disabled]="!canEdit"
                    (focusout)="validateRmis()"
                    />
                </td>
                <td class="pin-table-columns">
                  <input matInput class="form-control" type="number" id="{{ 'primary' + i }}"
                    value="{{ pinOverride.primaryOverride }}" (click)="editPins()" [disabled]="!canEdit"/>
                </td>
                <td class="pin-table-columns">
                  <input matInput class="form-control" type="number" id="{{ 'secondary' + i }}"
                    value="{{ pinOverride.secondaryOverride }}" (click)="editPins()" [disabled]="!canEdit"/>
                </td>
                <td class="pin-table-columns">
                  <input matInput class="form-control" type="number" id="{{ 'whole' + i }}"
                    value="{{ pinOverride.wholeProductOverride }}" (click)="editPins()" [disabled]="!canEdit"/>
                </td>
                <td class="pin-table-columns">
                  <input matInput class="form-control" type="number" id="{{ 'sampling' + i }}"
                    value="{{ pinOverride.samplingDistributionOverride }}" (click)="editPins()" [disabled]="!canEdit"/>
                </td>
                <td class="pin-table-columns">
                  <button [disabled]="!this.enableButtons || (isReadOnly$ | async)"
                    mat-button
                    [class.mat-base-button]="pinOverride.id === null"
                    [class.mat-raised-button]="pinOverride.id !== null"
                    matTooltip="{{ getRemoveButtonToolTip(pinOverride.id !== null) }}" type="button"
                    (click)="removePinOverrideAtIndex(i)"
                  [disabled]="!canEdit">Remove</button>
                </td>
              </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </form>
  </div>
}
